import { useStores } from "@hooks";
import { Grid } from "@material-ui/core";
import { ApiKeysAccess, McpSsoOwnAccess } from "./components";

export const ApiMcpKeys = () => {
  const { userStore } = useStores();
  const { isAdmin } = userStore;
  
  return (
    <Grid item container direction="column">
      <McpSsoOwnAccess/>
      {
        isAdmin &&
        <ApiKeysAccess />
      }
    </Grid>
  );
};
